import React, { useState, useEffect } from 'react'
import { Empty, message, Popconfirm, Table, Tooltip } from 'antd'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUnlink } from '@fortawesome/free-solid-svg-icons'

import StoreUserForm from './StoreUserForm'
import { deleteStoreUser, getStoreUsers } from '../../Stores/services'
import { handleError } from '../../../helpers'

export default function StoreUsersModal({ visible, onClose, storeId }) {
	const [storeUsers, setStoreUsers] = useState(null)

	useEffect(() => {
		!storeUsers && visible && getStoreUsers({
			'filter[store_id]': storeId,
		})
			.then(res => setStoreUsers(res.data.data))
			.catch(error => handleError(error))
	}, [ storeUsers, storeId, visible ])

	const handleDelete = id => {
		deleteStoreUser(id)
			.then(() => {
				message.success('Tienda desasociada exitosamente')
				setStoreUsers(null)
			})
			.catch(error => handleError(error))
	}

	const columns = [
		{
			title: 'Nombre de Usuario',
			dataIndex: 'user_name'
		},
		{
			title: 'Cargo',
			dataIndex: 'user_ranking_name'
		},
		{
			title: 'Acciones',
			render: (t, record) => (
				<React.Fragment>
					<Popconfirm
						title="¿Segura desea desasociar el usuario?"
						okText="Desasociar"
						cancelText="Cancelar"
						onConfirm={() => handleDelete(record.id)}
						okButtonProps={{ danger: true }}
					>
						<Tooltip title="Desasociar">
							<FontAwesomeIcon 
								className="text-link"
								icon={faUnlink}
							/>
						</Tooltip>
					</Popconfirm>
				</React.Fragment>
			)
		}
	]

	const handleClose = () => {
		onClose()
		setStoreUsers(null)
	}

	return (
		<Modal isOpen={visible} toggle={handleClose}>
			<ModalHeader toggle={handleClose}>Usuarios Asociados</ModalHeader>
			<ModalBody>
				<Table 
					dataSource={storeUsers}
					rowKey={record => record.id}
					columns={columns}
					size="small"
					locale={{ emptyText: <Empty description='No tiene usuarios asociadas' imageStyle={{ height: 60 }} /> }}
					loading={!storeUsers}
				/>
				<StoreUserForm 
					storeId={storeId}
					reload={() => setStoreUsers(null)}
				/>
			</ModalBody>
		</Modal>
	)
}